// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .btn:disabled {
  color: #6b6d6f;
  background-color: #dbdcdd;
  border-color: #dbdcdd;
}
::ng-deep .btn:disabled:hover {
  color: #6b6d6f;
  background-color: #dbdcdd;
  border-color: #dbdcdd;
}
::ng-deep .p-drawer .closeButton .p-button {
  background: #fff;
  border: none;
  color: #6b6d6f;
}
::ng-deep .p-drawer .closeButton .p-button .p-icon {
  height: 16px;
  width: 16px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
